import React, {useContext} from 'react';
import LangContext from '../../context/LangContext';
import {Typography} from '@material-ui/core/';
import helst1 from './Material/Helst1.jpg';
import helst2 from './Material/Helst2.jpg';
import helst3 from './Material/Helst3.jpg';
import helst4 from './Material/Helst4.jpg';
import helst5 from './Material/Helst5.jpg';
import helst6 from './Material/Helst6.jpg';
import helst7 from './Material/Helst7.jpg';
import helst8 from './Material/Helst8.jpg';


export const Helstdescription = (props) => {
  const [lang] = useContext(LangContext);
    return <>
      {lang==="se" ? <>
        <Typography variant="h5" gutterBottom>
        Trähörnet
        </Typography>
        <img style={{width: 320}} src={helst2} alt="helst" /><br/><br/>
        <Typography variant="h6" gutterBottom>
        Smedsby Trähöghus
        </Typography>
        Smedsby trähöghus blir en central del av centrumkvarteren med en naturlig kontakt till torget.<br/><br/>
        <img style={{width: 320}} src={helst1} alt="helst" /><br/>
        <img style={{width: 320}} src={helst3} alt="helst" /><br/>
        <img style={{width: 320}} src={helst4} alt="helst" /><br/>
        <img style={{width: 320}} src={helst5} alt="helst" /><br/>
        <img style={{width: 320}} src={helst6} alt="helst" /><br/>
        <img style={{width: 320}} src={helst7} alt="helst" /><br/>
        <img style={{width: 320}} src={helst8} alt="helst" /><br/>
      </> : <>
        <Typography variant="h5" gutterBottom>
        Puukulma
        </Typography>
        <img style={{width: 320}} src={helst2} alt="helst" /><br/><br/>
        <Typography variant="h6" gutterBottom>
        Sepänkylän Puukerrostalo
        </Typography>
        Sepänkylän puukerrostalosta tulee keskeinen osa keskustan korttelia josta on luonnollinen yhteys toriin.<br/><br/>
        <img style={{width: 320}} src={helst1} alt="helst" /><br/>
        <img style={{width: 320}} src={helst3} alt="helst" /><br/>
        <img style={{width: 320}} src={helst4} alt="helst" /><br/>
        <img style={{width: 320}} src={helst5} alt="helst" /><br/>
        <img style={{width: 320}} src={helst6} alt="helst" /><br/>
        <img style={{width: 320}} src={helst7} alt="helst" /><br/>
        <img style={{width: 320}} src={helst8} alt="helst" /><br/>
      </>}
    </>
};

export default Helstdescription;